import Loader from '@/components/Loader';
import NewArticle from '@/components/NewArticle';
import NewAudio from '@/components/NewAudio';
import NewLink from '@/components/NewLink';
import NewVideo from '@/components/NewVideo';
import Constants from '@/Constants';
import Item from '@/models/Item';
import { LanguageType } from '@/models/LanguageType';
import { ApplicationState } from '@/store';
import { getCategoriesRequest } from '@/store/category/action';
import { getItemRequest } from '@/store/item/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import './style.scss';

const EditItem: React.FC = () => {
    const [item, setItem] = useState<Item | null>(null);
    const [loading, setLoading] = useState(true);
    const [locale, setLocale] = useState<LanguageType>('');

    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { data: identity } = useSelector((state: ApplicationState) => state.identity);
    const { content } = useSelector((state: ApplicationState) => ({ content: (state.itens.data.itens as unknown) as Item }));

    const history = useHistory();
    const { id } = useParams();

    const dispatch = useDispatch();

    useEffect(() => {
        const {
            user: { orgId, applicationId },
        } = identity;
        dispatch(getCategoriesRequest({ orgId, applicationId }));
        dispatch(getItemRequest(Number(id)));
    }, [dispatch, identity, id]);

    useEffect(() => {
        if (content && content.id) {
            setItem(content);
            setLocale(content.locale);
            setLoading(false);
        }
    }, [content]);

    const renderTitle = () => {
        if (item) {
            switch (item.mediaType) {
                case 'HTML':
                    return strings.ARTICLE;
                case 'AUDIO':
                    return strings.AUDIO;
                case 'EXTERNAL':
                    return strings.LINK;
                case 'VIDEO':
                    return strings.VIDEO;
                default:
                    return strings.ITEM;
            }
        }
        return undefined;
    };

    const handleOnBackClick = () => {
        history.push('/contents/playlist/items');
    };

    return (
        <div className="edit-item">
            <div className="back-button go-back navbar navbar-expand sub-nav">
                <div>
                    <i className="material-icons-outlined align-middle" onClick={handleOnBackClick} onKeyDown={() => {}} role="button" tabIndex={0}>
                        {Constants.icons.ARROW_LEFT}
                    </i>
                    <span onClick={handleOnBackClick} onKeyDown={() => {}} role="button" tabIndex={0}>
                        {strings.GO_BACK}
                    </span>
                </div>
            </div>
            <div className="content">
                <div className="title">
                    <h1>{`${strings.EDIT} ${strings.ITEM}`}</h1>
                    <span className="item-type">{renderTitle()}</span>
                </div>

                {loading && <Loader />}
                {item && item.mediaType && (
                    <>
                        {item.mediaType.toString() === 'HTML' && <NewArticle handleOnCancel={handleOnBackClick} item={item} language={locale} />}
                        {item.mediaType.toString() === 'EXTERNAL' && <NewLink handleOnCancel={handleOnBackClick} item={item} language={locale} />}
                        {item.mediaType.toString() === 'VIDEO' && <NewVideo handleOnCancel={handleOnBackClick} item={item} language={locale} />}
                        {item.mediaType.toString() === 'AUDIO' && <NewAudio handleOnCancel={handleOnBackClick} item={item} language={locale} />}
                    </>
                )}
            </div>
        </div>
    );
};

export default EditItem;
